import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import axios from "axios";
import { base_url } from "../../context/Authcontext";

// RB-089: cookie presence is not enough. After login on another device, the
// users.token row is rotated and our cookie is stale. We must verify with the
// backend before rendering routes that handle money or PII.

const getCookie = (name) => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
};

const clearAuthCookies = () => {
  // The session cookie is HttpOnly now (#14); only the server can clear it.
  axios.post(`${base_url}/api/webapi/logout`, {}, { withCredentials: true }).catch(() => {});
  document.cookie = "token=; max-age=0; path=/;";
  document.cookie = "auth=; max-age=0; path=/;";
  // rb_session is the flag the UI reads for "signed in", and it is not
  // HttpOnly -- if the logout POST above fails it would otherwise stay at 1
  // and the app would keep acting logged in against a dead session.
  document.cookie = "rb_session=; max-age=0; path=/";
  [
    "hasSeenLoginModal",
    "username",
    "userbalance",
    "phoneNumber",
    "phone",
    "game_token",
    "userDataCache",
  ].forEach((k) => localStorage.removeItem(k));
};

const ProtectedRouteUser = () => {
  const [state, setState] = useState("checking"); // checking | ok | invalid

  useEffect(() => {
    // rb_session marks that the server issued a session; GetUserInfo below
    // still decides whether it is valid.
    const cookie = getCookie("rb_session");
    if (!cookie) {
      setState("invalid");
      return;
    }
    let cancelled = false;
    axios
      .post(
        `${base_url}/api/webapi/GetUserInfo`,
        {},
        {
          withCredentials: true,
          headers: { Accept: "application/json" },
          timeout: 10000,
        }
      )
      .then(() => {
        if (cancelled) return;
        // Only 401/403 (below) means the session is gone. A 200 whose body just
        // lacks `data` -- a shape change, a partial payload, an error the API
        // answers with 200 -- used to destroy a perfectly valid session, which
        // is what was signing players out at random.
        setState("ok");
      })
      .catch((err) => {
        if (cancelled) return;
        const code = err?.response?.status;
        if (code === 401 || code === 403) {
          clearAuthCookies();
          setState("invalid");
        } else {
          // network / 500 — optimistic allow so users aren't bounced on a flaky
          // network. The individual page's API calls will still 401 if stale.
          setState("ok");
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (state === "checking") {
    return (
      <div style={{ padding: 24, textAlign: "center", color: "#888" }}>
        Verifying session...
      </div>
    );
  }
  if (state === "invalid") {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
};

export default ProtectedRouteUser;
